import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ArrowRight, Sparkles } from "lucide-react";

export default function DemoFloatingCTA() {
  const { user } = useAuth();

  if (user?.email !== "demo@aurorageriatrica.com") return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 no-print print:hidden">
      <Link
        to="/register"
        className="flex items-center gap-2 rounded-2xl bg-emerald-600 px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-emerald-600/30 transition-all hover:bg-emerald-700 hover:shadow-xl hover:shadow-emerald-600/40 hover:-translate-y-0.5"
      >
        <Sparkles className="h-4 w-4" />
        Crear mi cuenta gratis
        <ArrowRight className="h-4 w-4" />
      </Link>
      <p className="mt-1.5 text-center text-[10px] text-slate-500">
        14 días gratis · Sin tarjeta
      </p>
    </div>
  );
}
